var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-media-match';
import { useIntl, defineMessages } from 'react-intl';
import Modal from '../Modal';
import Scroll from '../Scroll';
import useDebounce from '../hooks/useDebounce';
import InfoElement from './InfoElement';
import Calculator from './Calculator';
import InstallmentContextProvider, { useInstallmentCalculatorContext } from './Context';
import InfoElementSkeleton from './InfoElement/Skeleton';
export { Calculator, InstallmentContextProvider };
var messages = defineMessages({
    modalHeadline: {
        defaultMessage: 'Ratenrechner',
        id: 'installment-calculator.modal-headline',
    },
});
/**
 * <p>This is the installment calculator component. It can either be rendered as a preview box or as an inline component.</p>
 * <p>On initial load the preview box calls the installment calculator API with the given price and returns the calculated installment values.
 * If a valid response is returned the value of a single installment rate as well as the amount of rates will be displayed.</p>
 * <p>If the inline component is used the content to be rendered has to be passed via the parameter `content` and can either be
 * of type `JSX.Element` or `string`.</p>
 * <p>By clicking on the component a modalbox opens which enables the user to configure various values like e.g. the amount of installment rates.
 * The modalbox also provides a configurable option if the price should be editable or not. If a value changes the installment
 * calculator API will be called again and the values will be updated according to the newly calculated values returned from the API call.</p>
 */
export var InstallmentCalculator = function (_a) {
    var inlineContent = _a.inlineContent, _b = _a.isInline, isInline = _b === void 0 ? false : _b, _c = _a.isPriceEditable, isPriceEditable = _c === void 0 ? false : _c, _d = _a.source, source = _d === void 0 ? 'pdv' : _d;
    var mobile = useMedia({ desktop: false, mobile: true, tablet: false });
    var _e = useState(false), isShowModal = _e[0], setIsShowModal = _e[1];
    var intl = useIntl();
    var _f = useInstallmentCalculatorContext(), _g = _f.config, cardIdentifier = _g.cardIdentifier, isCardLayout = _g.isCardLayout, error = _f.error, isLoading = _f.isLoading, response = _f.response, setIsPriceEditable = _f.setIsPriceEditable, setInstallmentRequestSource = _f.setInstallmentRequestSource;
    var isDebouncedLoading = useDebounce(isLoading, 500);
    var modalProps = {
        large: !mobile,
    };
    useEffect(function () {
        setIsPriceEditable(isPriceEditable);
        setInstallmentRequestSource(source);
    }, []);
    return (React.createElement(React.Fragment, null,
        (error || (response && response.error)) && (React.createElement("span", { "data-testid": "installment-calculator-error", "data-error": response && response.error })),
        isDebouncedLoading && React.createElement(InfoElementSkeleton, null),
        response && !response.error && (React.createElement("div", { "data-testid": "installment-calculator" }, isCardLayout ? (React.createElement(Scroll, { duration: 500, render: function (scroll) { return (React.createElement(InfoElement, { inlineContent: inlineContent, isInline: isInline, onClick: function () {
                    scroll();
                } })); }, positionAfterScroll: "#" + cardIdentifier })) : (React.createElement(React.Fragment, null,
            React.createElement(InfoElement, { inlineContent: inlineContent, isInline: isInline, onClick: function () { return setIsShowModal(true); } }),
            React.createElement(Modal
            // modalprops can't be passed in an other way
            // eslint-disable-next-line
            , __assign({}, modalProps, { noContentPadding: true, onRequestClose: function () { return setIsShowModal(false); }, open: isShowModal, headline: intl.formatMessage(messages.modalHeadline) }),
                React.createElement(Calculator, null))))))));
};
export default InstallmentCalculator;
//# sourceMappingURL=index.js.map